import SeedAuthenticationApi from '../data/api/seed-authentication-api';
import { APP_STATE_ACTION_TYPE_USER } from '../state/seed-states';

class SeedAuthenticationRepository {
  constructor(state, dispatch) {
    this.state = state;
    this.dispatch = dispatch;
    this.api = new SeedAuthenticationApi();
    // this.db = db;
  }

  register(data) {
    return this.api.register(data);
  }

  login(data) {
    return this.api.login(data);
  }

  isAuthenticated() {
    const currentUser = this.state[APP_STATE_ACTION_TYPE_USER];
    if (currentUser) {
      return true;
    }
    // If user is falsy, return false.
    return false;
  }

  logout() {
    this.dispatch({
      type: APP_STATE_ACTION_TYPE_USER,
      value: '',
      valueType: 'json',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  saveUser(data) {
    this.dispatch({
      type: APP_STATE_ACTION_TYPE_USER,
      value: {
        ...data,
        avatar: {
          title: data.user.name || data.user.email,
          subtitle: data.user.email,
        },
      },
      valueType: 'json',
    });
  }
}

export default SeedAuthenticationRepository;
